const studentSpace = {
  path: 'studentSpace',
  component: resolve => require(['../../../../components/pages/signUp/studentSpace'], resolve)
}
export default studentSpace
